export default "__VITE_ASSET__DPhL$gJk__"